import React, { useEffect, useState } from 'react';

import { useCasinoFavorites } from '@atlas/core';

import GameList from 'components/Pages/Casino/GameList/GameList';
import InfiniteScroller from 'components/Pages/Casino/InfiniteScroller';

import LoadMoreButton from './LoadMoreButton';

const noop = () => {};

export const CasinoFavoritesGames = ({ activeItem, scrollParent, sliderSettings }) => {
  const [isEnableInfinityScroll, setIsEnableInfinityScroll] = useState(false);
  const { games, hasMore, isLoaded, isLoading, loadMore } = useCasinoFavorites();
  const canRenderLoadMoreButton = !isEnableInfinityScroll && !isLoading && hasMore;

  useEffect(() => {
    loadMore();
  }, []);

  const handleEnableInfinityScroll = () => {
    loadMore();
    setIsEnableInfinityScroll(true);
  };

  return (
    <InfiniteScroller
      getScrollParent={scrollParent}
      hasMore={hasMore && isEnableInfinityScroll}
      isLoading={isLoading}
      isResolved
      loadMore={isEnableInfinityScroll ? loadMore : noop}
      useWindow={false}
    >
      <GameList
        activeItem={activeItem}
        games={games}
        hasLoadMoreButton={canRenderLoadMoreButton}
        isEnableInfinityScroll={isEnableInfinityScroll}
        isFavorites
        isLoading={isLoading}
        isResolved={isLoaded}
        sliderSettings={sliderSettings}
      />
      <LoadMoreButton handleClick={handleEnableInfinityScroll} isShow={canRenderLoadMoreButton} />
    </InfiniteScroller>
  );
};
